module.exports = __webpack_public_path__ + "img/27.1.43587a05.png";